import React from 'react';
import styles from './ActivityItem.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import moment from 'moment';

const ActivityItem = ({ data }) => {
  return (
    <div className={styles['activity-item']}>
      <div className={styles['icon-container']}>
        <SvgWithBranding
          type='rocket2'
          className={styles['icon']}
          color='#128DEA'
        />
      </div>
      <div className={styles['text-container']}>
        <p className={styles['text']}>{data?.description}</p>
        <p className={styles['time']}>
          {data?.actionDate ? moment(data.actionDate).fromNow() : ''}
        </p>
      </div>
    </div>
  );
};

export default ActivityItem;
